import gallery from './gallery.json';

// Add or update entries in gallery.json; the page, albums and filters update automatically.
export const work = gallery.map(photo => ({
  ...photo,
  thumbnail: `/images/bodyshop-work/${photo.id}-640.webp`,
  image: `/images/bodyshop-work/${photo.id}-1280.webp`,
  imageWidth: photo.imageWidth || 1280,
}));

export const categories = ['All work', 'Paintwork', 'Panels & bumpers', 'Preparation'];

export const collections = [
  { id: 'blue-saloon', title: 'Blue saloon', cover: '8463' },
  { id: 'white-estate', title: 'White estate', cover: '8528' },
  { id: 'dark-estate', title: 'Dark estate', cover: '8576' },
  { id: 'grey', title: 'Grey hatchback', cover: '8651' },
  { id: 'silver', title: 'Silver paintwork', cover: '8316' },
  { id: 'black', title: 'Black paintwork', cover: '7998' },
  { id: 'white', title: 'White paintwork', cover: '8024' },
  { id: 'blue', title: 'Blue paintwork', cover: '7981' },
  { id: 'panels', title: 'Bonnets & bumpers', cover: '8052' },
  { id: 'classics', title: 'Classics', cover: '4460' },
];
export const filterWork = (category, collection) => work.filter(photo =>
  (category === 'All work' || photo.category === category) &&
  (collection === 'all' || photo.collection === collection)
);


